import React from "react"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import { templateActions, getTemplates } from "data/templateApi"

class WithTemplates extends React.Component {
    render() {
        const templatesData = this.props.templates
        if (!templatesData) return this.props.loading ? this.props.loading : ""
        const templates = Object.values(templatesData)
        return this.props.children({
            templates,
            clone: templateActions.clone,
        })
    }

    constructor(props) {
        super(props)
        props.templateActions.fetch()
    }
}

WithTemplates.propTypes = {}

function mapStateToProps(state) {
    return {
        templates: getTemplates(state),
    }
}

function mapDispatchToProps(dispatch) {
    return {
        templateActions: bindActionCreators(templateActions, dispatch),
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(WithTemplates)



// WEBPACK FOOTER //
// ./src/data/wrappers/WithTemplates.js